import React from 'react';
import CommonSVGIcon, { Props } from '@/components/icons/CommonSVGIcon';

export default function (props: Props) {
  return (
    <CommonSVGIcon {...props} viewBox="0 0 18 18">
      <path d="M1.5 3C1.5 2.17157 2.17157 1.5 3 1.5H15C15.8284 1.5 16.5 2.17157 16.5 3V15C16.5 15.8284 15.8284 16.5 15 16.5H3C2.17157 16.5 1.5 15.8284 1.5 15V3Z"/>
      <path d="M4.5 8.1H13.5V9.9H4.5V8.1Z" fill="#FFFFFF"/>
    </CommonSVGIcon>
  );
}